import Swal from "sweetalert2";

export function delete_survey(survey_id) {
  const normalized_id = String(survey_id ?? "");
  Swal.fire({
    title: "Are you sure?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    position: 'bottom-end',
    toast: true
  }).then((result) => {
    if (!result.isConfirmed) return;
    $.ajax({
      type: "DELETE",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/delete_survey/`,
      data: JSON.stringify({ survey_id }),
      headers: {
        Authorization: `Token ${this.get_token()}`,
        "Content-Type": "application/json",
      },
      success: (response) => {
        if (response.status === "success") {
          if (Array.isArray(this.current_event?.survey)) {
            this.current_event.survey = this.current_event.survey.filter(
              (s) => String(s?.survey?.id || s?.id) !== normalized_id
            );
          } else if (Array.isArray(this.event?.survey)) {
            this.event.survey = this.event.survey.filter(
              (s) => String(s?.survey?.id || s?.id) !== normalized_id
            );
          }
          this.$emit('survey-deleted', survey_id);
          if (this.inline) {
            this.show_event_survey_form = false;
            if (typeof this.reset_inline_form === "function") {
              this.reset_inline_form();
            }
          }
          Swal.fire({
            title: "Deleted!",
            text: "The survey has been deleted.",
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
            position: 'bottom-end',
            toast: true
          });
        } else {
          Swal.fire({
            title: "Failed!",
            text: response.message || "An error occurred. Please try again.",
            icon: "error",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      },
      error: (xhr) => {
        Swal.fire({
          title: "Failed!",
          text: xhr.responseJSON?.message || "An error occurred. Please try again.",
          icon: "error",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
      },
    });
  });
}

export function get_question_types() {
  this.token_exists = this.get_token();
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
    method: "GET",
    headers: { Authorization: `Token ${this.get_token()}` },
    success: (response) => {
      this.question_types = response.data.question_types;
    },
  });
}

export function fetch_questions() {
  this.token_exists = this.get_token();
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
    method: "POST",
    headers: this.token_exists ? { Authorization: `Token ${this.get_token()}` } : {},
    success: (response) => {
      this.questions = response.data.questions;
    },
  });
}

export function submit_survey() {
  // Survey name/description are derived from the event (not shown in the UI)
  if (!this.survey_name || !String(this.survey_name).trim()) {
    const ev = this.current_event || this.event || {};
    this.survey_name = ev?.event_name || ev?.name || this.survey_name || "";
  }
  if (!this.survey_description || !String(this.survey_description).trim()) {
    const ev = this.current_event || this.event || {};
    this.survey_description = ev?.description || ev?.event_description || this.survey_description || "";
  }

  if (!this.validation_for_survey_name()) {
    return;
  }

  if (!this.survey_id && this.has_survey) {
    Swal.fire({
      icon: "info",
      title: "Survey already exists",
      text: "Only one survey is allowed for this event. Please edit or delete the existing survey.",
      showConfirmButton: false,
      timer: 2500,
      position: "bottom-end",
      toast: true,
    });
    return;
  }

  if (this.$refs?.quill_survey_editor_ref?.getHTML) {
    this.survey_description = this.$refs.quill_survey_editor_ref.getHTML();
    this.survey_description = this.survey_description.replace(/<\/?p>/g, "").trim();
  } else {
    this.survey_description = String(this.survey_description || "").trim();
  }

  if (!this.survey_description || this.survey_description === "<br>" || this.survey_description === "<br/>") {
    this.survey_description = "";
  }

  const createSurvey = () => {
    const event_id = this.current_event_id ?? this.event_id;
    if (!event_id) {
      Swal.fire({
        icon: "error",
        title: "Missing event",
        text: "Unable to create a survey because the event id is missing.",
        showConfirmButton: false,
        timer: 2500,
        position: "bottom-end",
        toast: true,
      });
      return;
    }

    const ev = this.current_event || this.event || {};
    const name = String(this.survey_name || "").trim() || (ev?.event_name || ev?.name || "");
    const description = String(this.survey_description || "").trim() || (ev?.description || ev?.event_description || "");

    const payload = {
      name,
      description,
      questions: this.selected_questions.map((q) => q.id),
      group_id: null,
      portal_id: null,
      event_id,
    };
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/create_survey/`,
      method: "POST",
      headers: {
        Authorization: `Token ${this.get_token()}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
      success: (response) => {
        Swal.fire({
          icon: "success",
          title: "Survey Created",
          text: "Your survey has been successfully created!",
          showConfirmButton: false,
          timer: 2000,
          position: 'bottom-end',
          toast: true
        }).then(() => {
          const created_survey = response?.survey || response?.data?.survey || response?.data;
          if (created_survey?.id && this.current_event) {
            if (!Array.isArray(this.current_event.survey)) {
              this.current_event.survey = [];
            }
            this.current_event.survey.unshift({ survey: created_survey });
          }
          if (created_survey?.id) {
            this.$emit('survey-updated', created_survey);
          }
          this.survey_name = "";
          this.survey_description = "";
          this.questions = [];
          this.selected_questions = [];
          this.created_questions = [];
          this.errors = {};
          if (this.$refs.quill_survey_editor_ref) {
            this.$refs.quill_survey_editor_ref.setHTML("");
          }
          if (this.inline) {
            this.show_event_survey_form = false;
          } else {
            $("#create_survey").modal("hide");
          }
        });
      },
      error: (xhr) => {
        Swal.close();
        if (xhr?.responseJSON?.message) {
          this.errors.survey_name = xhr.responseJSON.message;
        }
      },
    });
  };

  if (this.survey_id) {
    if (this.new_question.text && this.new_question.type) {
      this.add_question_to_survey()
        .then(() => this.update_survey_form())
        .catch((error) => {
          console.error("Error adding question:", error);
        });
      return;
    }
    this.update_survey_form();
    return;
  }

  if (this.new_question.text && this.new_question.type) {
    this.add_question_to_survey()
      .then(() => createSurvey())
      .catch((error) => {
        console.error("Error adding question:", error);
      });
    return;
  }

  createSurvey();
}

export function update_survey_form() {
  const ev = this.current_event || this.event || {};
  const name = String(this.survey_name || "").trim() || (ev?.event_name || ev?.name || "");
  const description = String(this.survey_description || "").trim() || (ev?.description || ev?.event_description || "");

  const payload = {
    survey_id: this.survey_id,
    name,
    description,
    questions: this.selected_questions.map((q) => q.id),
  };

  Swal.fire({
    title: "Updating survey...",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/update_survey/`,
    method: "POST",
    headers: {
      Authorization: `Token ${this.get_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(payload),
    success: (response) => {
      Swal.fire({
        icon: "success",
        title: "Survey Updated",
        text: "Your survey has been successfully updated!",
        showConfirmButton: false,
        timer: 2000,
        position: 'bottom-end',
        toast: true
      }).then(() => {
        const updated_survey = response?.survey || response?.data?.survey || response?.data;
        if (updated_survey?.id && Array.isArray(this.current_event?.survey)) {
          const idx = this.current_event.survey.findIndex((s) => (s?.survey?.id || s?.id) === updated_survey.id);
          if (idx !== -1) {
            this.current_event.survey.splice(idx, 1, { survey: updated_survey });
          }
        }
        if (updated_survey?.id) {
          this.$emit('survey-updated', updated_survey);
        }
        this.survey_id = null;
        this.survey_name = "";
        this.survey_description = "";
        this.questions = [];
        this.selected_questions = [];
        this.created_questions = [];
        if (this.$refs.quill_survey_editor_ref) {
          this.$refs.quill_survey_editor_ref.setHTML("");
        }
        if (this.inline) {
          this.show_event_survey_form = false;
          if (typeof this.reset_inline_form === "function") {
            this.reset_inline_form();
          }
        } else {
          $("#create_survey").modal("hide");
        }
      });
    },
    error: () => {
      Swal.fire({
        icon: "error",
        title: "Cannot Edit Survey",
        text: "This survey has already been answered and cannot be edited.",
        confirmButtonText: "OK",
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
    },
  });
}

function reset_question_form(ctx) {
  ctx.new_question = { text: "", question_number: "", type: "", options: [], is_mandatory: false };
}

function build_question_form_data(new_question) {
  const form_data = new FormData();
  form_data.append("question", new_question.text);
  form_data.append("question_type", new_question.type);
  form_data.append("question_number", new_question.question_number);
  form_data.append("is_mandatory", new_question.is_mandatory);

  (new_question.options || []).forEach((opt) => {
    if (opt.text && opt.text.trim()) form_data.append("options", opt.text.trim());
  });
  return form_data;
}

export function add_question_to_survey() {
  return new Promise((resolve, reject) => {
    const nq = this.new_question;

    if (!nq.text || !nq.type || !nq.question_number) {
      Swal.fire({ icon: "error", title: "Missing Information", text: "Please fill in all required fields for the question" ,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      toast: true
      });
      return reject("Missing required fields");
    }

    const existing = this.questions.find((q) => q.question === nq.text);

    // 2. Guard Clause: Existing Question Flow
    if (existing) {
      if (!this.selected_questions.some((q) => q.id === existing.id)) {
        this.selected_questions.push(existing);
        this.created_questions.push({
          text: existing.question, id: existing.id,
          type: existing.question_type.id, is_mandatory: existing.is_mandatory || false,
        });
      }
      reset_question_form(this);
      Swal.fire({ icon: "success",
        title: "Question Added",
        text: "Existing question has been added to your survey",
        showConfirmButton: false, timer: 1500 ,
      position: 'bottom-end',
      toast: true
      });
      return resolve();
    }

    // 3. New Question Flow
    Swal.fire({ title: "Creating question...", allowOutsideClick: false, didOpen: () => Swal.showLoading() });

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
      method: "POST",
      headers: { Authorization: `Token ${this.get_token()}` },
      data: build_question_form_data(nq),
      processData: false,
      contentType: false,
      success: (response) => {
        if (response.status !== "success") return reject("Failed to create question");

        const q = response.question_data;
        if (!q || !q.id) {
          Swal.fire({ icon: "warning",
            title: "Question Created",
            text: "Question was created but could not be added to survey. Please try again.",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
          });
          return reject("Question created but missing ID");
        }

        this.selected_questions.push({ id: q.id, question: q.question });
        this.created_questions.push({ text: q.question, id: q.id, type: q.question_type.id, is_mandatory: q.is_mandatory || false });
        reset_question_form(this);
        this.fetch_questions();
        Swal.fire({ icon: "success",
          title: "Question Created",
          text: "New question has been created and added to your survey",
          showConfirmButton: false, timer: 1500 ,
        position: 'bottom-end',
        toast: true
        });
        resolve(q);
      },
      error: () => {
        Swal.fire({ icon: "error",
          title: "Error",
          text: "Failed to create question on survey.",
          showConfirmButton: false, timer: 1500 ,
        position: 'bottom-end',
        toast: true
        });
        reject("Failed to create question");
      },
    });
  });
}

export function submit_event_survey_answers() {
  const survey = this.event_survey;
  if (!survey?.id) return;

  const form_data = new FormData();
  form_data.append("survey_id", survey.id);

  const answered_questions = [];
  this.event_survey_errors = [];
  this.event_survey_first_error_question_id = null;

  const valid_question_ids = Array.isArray(survey.survey_questions)
    ? survey.survey_questions.map((q) => q?.question?.id).filter(Boolean)
    : [];

  for (const question_id of valid_question_ids) {
    const answer = Reflect.get(this.event_survey_answers, question_id);

    const is_empty =
      answer === undefined ||
      answer === null ||
      (Array.isArray(answer) && answer.length === 0) ||
      (typeof answer === "string" && answer.trim() === "");

    if (is_empty) {
      if (!this.event_survey_first_error_question_id) {
        this.event_survey_first_error_question_id = question_id;
      }

      const exists = this.event_survey_errors.find((error) => error.id === question_id);
      if (!exists) {
        this.event_survey_errors.push({
          id: question_id,
          message: "This question requires an answer.",
        });
      }
      continue;
    }

    answered_questions.push({
      question_id: Number(question_id),
      answer: Array.isArray(answer) ? answer.join(",") : answer,
    });
  }

  if (this.event_survey_errors.length > 0) {
    Swal.fire({
      icon: "error",
      title: "Incomplete",
      text: "Please answer all required questions before submitting.",
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      toast: true
    });
    return;
  }

  form_data.append("answers", JSON.stringify(answered_questions));

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/answer_survey/`,
    headers: {
      Authorization: `Token ${this.get_token()}`,
    },
    data: form_data,
    processData: false,
    contentType: false,
    success: (response) => {
      if (response.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your answers have been submitted successfully!",
          showConfirmButton: false,
          timer: 1500,
          position: 'bottom-end',
          toast: true
        });
        survey.is_answered = true;
        this.show_event_survey_form = false;
        this.show_event_survey_answers = false;

        const current_user_id = this.user_details?.id;
        const answers = response.data.answers || [];

        for (const ans of answers) {
          const question_id =
            ans.survey_question?.question?.id || ans.survey_question?.id;
          const q = survey.survey_questions.find((q) => q.question.id === question_id);
          if (q) {
            if (!q.answers) q.answers = [];
            const existing = q.answers.find((a) => a.user?.id === current_user_id);
            if (!existing) {
              q.answers.push({
                id: ans.id,
                answer: ans.answer,
                user: ans.user,
              });
            }
          }
        }
      }
    },
    error: () => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong. Please try again later.",
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
    },
  });
}
